var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.loading)?_c('ListView',{class:_vm.css,attrs:{"cols":_vm.listViewCols,"items":_vm.skeletons},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('v-skeleton-loader',{attrs:{"type":_vm.dummyType}})]},proxy:true}],null,false,3757523169)}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }